import { render, staticRenderFns } from "./form-calendar.vue?vue&type=template&id=32996c34&scoped=true"
import script from "./form-calendar.vue?vue&type=script&lang=js"
export * from "./form-calendar.vue?vue&type=script&lang=js"
import style0 from "./form-calendar.vue?vue&type=style&index=0&id=32996c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32996c34",
  null
  
)

export default component.exports